/**
 * 提交弹窗状态
 */
export const SUBMIT_DIALOG_STATUS = {
  NOT_SUBMIT: 0,
  SUBMITTING: 1,
  SUCCESS: 2,
  FAIL: 3,
};

/**
 * 报错表格状态列枚举
 */
export const SUBMIT_ERROR_STATUS = {
  FAIL: 1,
  RETRYING: 2,
  SUCCESS: 3,
};

/** 后端返回创意提交状态  */
export const CREATIVE_SUBMIT_STATUS = {
  ALL_SUCCESS: 1,
  SOME_FAIL: 2,
};

/**
 * 提交中和提交成功的GIF图地址
 */
export const CREATION_SUBMIT_ICON = {
  SUBMITTING:
    'https://p16-ttam-va.ibyteimg.com/tos-maliva-i-o1lobgzm8y-us/va-creation-submitting.gif~tplv-o1lobgzm8y-image.image',
  SUCCESS:
    'https://p16-ttam-va.ibyteimg.com/tos-maliva-i-o1lobgzm8y-us/va-creation-success_v1.gif~tplv-o1lobgzm8y-gif-75-origin:0:0.image',
};
